import { render, staticRenderFns } from "./KabSubscribe.vue?vue&type=template&id=4c4851df&scoped=true&"
import script from "./KabSubscribe.vue?vue&type=script&lang=js&"
export * from "./KabSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./KabSubscribe.vue?vue&type=style&index=0&id=4c4851df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4851df",
  null
  
)

export default component.exports